<template>
    <OrderingTableSettingsSection title="Accès par QR code" icon="maximize"
        description="Choisis quand le client doit rescanner pour passer commande. Le suivi reste toujours accessible."
        class="qr-scan-settings" :disabled="disabled">

        <div class="scan-setting">
            <div>
                <label for="qr-after-order" class="fw-semibold mb-1">Un nouveau scan pour chaque commande</label>
                <p id="qr-after-order-help" class="text-muted small mb-0">Après l’envoi d’une commande, le client doit rescanner pour en passer une autre.</p>
            </div>
            <ToggleInput input-id="qr-after-order" :value="value.qr_scan_invalidate_after_order" :disabled="disabled"
                described-by="qr-after-order-help" @input="update('qr_scan_invalidate_after_order', $event)" />
        </div>

        <div class="scan-setting">
            <div>
                <label for="qr-opening-hours" class="fw-semibold mb-1">Limiter les scans QR à certains horaires</label>
                <p id="qr-opening-hours-help" class="text-muted small mb-0">Le scan doit avoir lieu pendant un créneau défini pour autoriser une commande. Hors créneau, la carte et le suivi restent accessibles.</p>
            </div>
            <ToggleInput input-id="qr-opening-hours" :value="value.qr_scan_check_opening_hours" :disabled="disabled"
                described-by="qr-opening-hours-help" @input="update('qr_scan_check_opening_hours', $event)" />
        </div>

        <OrderingTableOpeningHours v-if="value.qr_scan_check_opening_hours" :value="openingHours" :timezone="timezone" :errors="errors" :disabled="disabled"
            @input="$emit('hours-change', $event)" />

        <div class="scan-setting">
            <div>
                <label for="qr-duration-enabled" class="fw-semibold mb-1">Limiter la durée après un scan</label>
                <p id="qr-duration-help" class="text-muted small mb-0">Le délai commence au dernier scan QR. Consulter le suivi ne le prolonge pas.</p>
            </div>
            <ToggleInput input-id="qr-duration-enabled" :value="value.qr_scan_duration_enabled" :disabled="disabled"
                described-by="qr-duration-help" @input="update('qr_scan_duration_enabled', $event)" />
        </div>
        <div v-if="value.qr_scan_duration_enabled" class="scan-details">
            <div class="d-flex flex-wrap gap-3">
                <div class="scan-duration-field">
                    <label class="form-label" for="qr-duration">Durée</label>
                    <input id="qr-duration" type="number" class="form-control" min="1" step="1" required
                        :aria-invalid="errors.qr_scan_duration_value ? 'true' : undefined" :aria-describedby="errors.qr_scan_duration_value ? 'qr-duration-error' : 'qr-duration-help'"
                        :max="value.qr_scan_duration_unit === 'hours' ? 168 : 10080" :value="value.qr_scan_duration_value"
                        @input="update('qr_scan_duration_value', Number($event.target.value))" />
                </div>
                <div class="scan-duration-field">
                    <label class="form-label" for="qr-duration-unit">Unité</label>
                    <select id="qr-duration-unit" class="form-select" :value="value.qr_scan_duration_unit"
                        @change="update('qr_scan_duration_unit', $event.target.value)">
                        <option value="minutes">Minutes</option>
                        <option value="hours">Heures</option>
                    </select>
                </div>
            </div>
            <p v-if="errors.qr_scan_duration_value" id="qr-duration-error" class="small text-danger mt-2 mb-0">{{ errors.qr_scan_duration_value[0] }}</p>
            <p class="small text-muted mt-2 mb-0">Maximum : 7 jours. Un paiement déjà commencé peut être terminé après l’expiration.</p>
        </div>
        <p class="small text-muted mt-4 mb-0">Ces réglages s’appliquent aux prochains scans. Toutes les options désactivées : aucune restriction de commande liée au scan.</p>
    </OrderingTableSettingsSection>
</template>

<script>
import ToggleInput from "../../../../components/forms/ToggleInput.vue";
import OrderingTableSettingsSection from "./OrderingTableSettingsSection.vue";
import OrderingTableOpeningHours from "./OrderingTableOpeningHours.vue";

export default {
    components: { ToggleInput, OrderingTableSettingsSection, OrderingTableOpeningHours },
    props: {
        value: { type: Object, required: true },
        openingHours: { type: Object, required: true },
        timezone: { type: String, required: true },
        disabled: { type: Boolean, default: false },
        errors: { type: Object, default: () => ({}) },
    },
    emits: ["input", "hours-change"],
    methods: {
        update(key, value) { this.$emit("input", { ...this.value, [key]: value }); },
    },
};
</script>

<style scoped>
.scan-setting { display: flex; justify-content: space-between; align-items: center; gap: 1.5rem; padding: 1.1rem 0; }
.scan-setting:not(:first-child) { border-top: 1px solid #e9ecef; }
.scan-setting:first-child { padding-top: 0; }
.scan-setting > .lead-switch { flex-shrink: 0; }
.scan-details { background: #f8f9fa; border-radius: 12px; padding: 1rem; }
.scan-duration-field { flex: 1 1 140px; max-width: 240px; }
</style>
